import DataGroup from './DataGroup'
import angular from 'angular'

export default angular
  .module('components.tb.dataGroup', ['react'])
  .directive(
    'tbDataGroup',
    (reactDirective, $auth, $http, StoreService) =>
      reactDirective(DataGroup, [], {}, { $auth, $http, StoreService })
  )
